import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "blocked-overlay" }
const _hoisted_2 = { class: "blocked-overlay__message" }

import { capIsNativePlatform } from '@exchange/libs/utils/capacitor/src';
import handleNativeGoTo from '@exchange/libs/utils/capacitor/src/lib/handle-native-go-to';


export default /*#__PURE__*/_defineComponent({
  __name: 'BlockedOverlay',
  setup(__props) {

const contactSupport = () => {
  const supportUrl = 'https://support.onetrading.com/requests/new';

  if (capIsNativePlatform()) {
    handleNativeGoTo(supportUrl);
  } else {
    window.location.href = supportUrl;
  }
};

return (_ctx: any,_cache: any) => {
  const _component_i18n_t = _resolveComponent("i18n-t")!
  const _component_x_button = _resolveComponent("x-button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("p", _hoisted_2, _toDisplayString(_ctx.$t('modules.transactions.userBlocked.title')), 1),
    _createVNode(_component_x_button, {
      class: "blocked-overlay__button",
      variant: "primary",
      onClick: contactSupport
    }, {
      default: _withCtx(() => [
        _createVNode(_component_i18n_t, {
          keypath: "modules.transactions.userBlocked.text",
          scope: "global"
        }, {
          linkText: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t('modules.transactions.userBlocked.linkText')), 1)
          ]),
          _: 1
        })
      ]),
      _: 1
    })
  ]))
}
}

})